import { Checkbox, FormControlLabel, InputLabel } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import GoogleButton from 'react-google-button';

import { AccessControlEnum } from '../../../../graphql/gen/types';
import { colorPalette, textSizes, TextSizesEnum } from '../../../../theme';
import { ButtonColor } from '../../../shared/primitives/PlexButton';
import { PlexButtonHref } from '../../../shared/primitives/PlexButtonHref';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';
import { Heading } from '../Heading';
import { SettingsContent } from '../SettingsContent';
import { SettingsPageProps } from './types';

export const Integrations = ({
  savedSettings,
  unsavedSettings,
  loadingMutation,
  onChange,
  onSave,
  onCancel,
  updateDisabled,
}: SettingsPageProps): React.ReactElement => {
  const classes = useStyles();
  const slackAccountName = savedSettings.domain?.slackWorkspace?.name;

  return (
    <SettingsContent
      title={'Integrations'}
      onSave={onSave}
      onCancel={onCancel}
      updateDisabled={updateDisabled}
      loadingMutation={loadingMutation}
    >
      <Heading text="Apps" />

      {savedSettings.accessControl === AccessControlEnum.DomainAdmin && (
        <>
          <FormControlLabel
            className={classes.checkbox}
            control={
              <Checkbox
                checked={!unsavedSettings.domain?.resetSlackIntegration && !!slackAccountName}
                name="slack"
                color="primary"
                onChange={(event, checked): void => {
                  if (slackAccountName != null) {
                    onChange({ domain: { resetSlackIntegration: !checked } });
                  }
                }}
              />
            }
            label="Slack"
          />
          <div className={classes.appContainer}>
            <div>
              <InputLabel id={'account-label'} className={classes.label}>
                {'Account'}
              </InputLabel>
              <PlexTypography text={slackAccountName || '-'} size={TextSizesEnum.Large} className={classes.text} />
            </div>
            <PlexButtonHref
              href={'/api/slack/auth'}
              className={classes.connectButton}
              color={ButtonColor.Purple}
              label={!slackAccountName ? 'Connect' : 'Connected'}
              disabled={!!slackAccountName}
            />
          </div>
        </>
      )}
      <FormControlLabel
        className={classes.checkbox}
        control={<Checkbox checked={savedSettings.hasExtraGSuiteScopes || false} name="gsuite" color="primary" />}
        label="GSuite Apps (allow Plex to import Google Calendars & Events, Google Docs and display Google Drive meta data)"
      />
      <div className={classes.appContainer}>
        <div>
          <InputLabel id={'account-label'} className={classes.label}>
            {'Account'}
          </InputLabel>
          <PlexTypography text={savedSettings.email || '-'} size={TextSizesEnum.Large} className={classes.text} />
        </div>
        <GoogleButton
          className={classes.connectButton}
          onClick={(): unknown =>
            (window.location.href = savedSettings.hasExtraGSuiteScopes
              ? '/api/auth/google/basic-scopes'
              : '/api/auth/google/extra-scopes')
          }
          type="dark"
        />
      </div>
    </SettingsContent>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    checkbox: {
      width: '100%',
      paddingLeft: 48,
      paddingTop: 22,
      paddingBottom: 24,
    },
    appContainer: {
      width: '100%',
      paddingLeft: 80,
      display: 'flex',
      flexDirection: 'row',
    },
    connectButton: {
      marginLeft: 50,
    },
    text: {
      fontWeight: 600,
      paddingTop: 4,
      width: 300,
    },
    labelRoot: {
      paddingLeft: 37,
      borderBottom: `1px solid ${colorPalette.gray._300}`,
      height: 75,
      margin: 0,
    },
    label: {
      ...textSizes[TextSizesEnum.NormalPlus],
      fontWeight: 500,
    },
  })
);
